import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgcCookieConsentService, NgcStatusChangeEvent, NgcNoCookieLawEvent, WindowService, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../environments/environment';
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { RouterModule } from '@angular/router'; // Asegúrate de importar RouterModule
import { isPlatformBrowser } from '@angular/common'; // Importar para verificar el entorno

declare var $: any;

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [FooterComponent, RouterModule, HeaderComponent], // Asegúrate de importar RouterModule
  providers: [WindowService, NgcCookieConsentService, NgcCookieConsentConfig] // Agregar el proveedor aquí
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe$: Subject<void> = new Subject<void>(); // Maneja las suscripciones
  private ccService!: NgcCookieConsentService;

  title = 'gm-shop';
  ICON = environment.ICON;
  TITLE = environment.TITLE;

  favIcon: HTMLLinkElement | null = null;
  appTitle: HTMLTitleElement | null = null;

  constructor(
    private router: Router,
    @Inject(NgcCookieConsentService) private cookieConsentService: NgcCookieConsentService,
    @Inject(PLATFORM_ID) private platformId: any // Inyectar PLATFORM_ID
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Solo ejecutar esto en el navegador
      this.favIcon = document.querySelector('#appIcon');
      this.appTitle = document.querySelector('#appTitle');

      this.changeIcon();
      this.changeTitle();

      // Este es el lugar correcto para usar `window`
      window.scrollTo(0, 0); // Aseguramos que solo se ejecute en el cliente
    }

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo(0, 0); // Solo en el navegador
        }
      }
    });

    if (environment.COOKIE_VER) {
      this.consentOnInit();
      this.subscribeToCookieConsentEvents(); // Asegúrate de subscribir a los eventos de consentimiento de cookies
    }
  }

  changeIcon(): void {
    if (this.favIcon) {
      this.favIcon.href = this.ICON;
    }
  }

  changeTitle(): void {
    if (this.appTitle) {
      this.appTitle.innerHTML = this.TITLE;
    }
  }

  consentOnInit(): void {
    const content = this.cookieConsentService.getConfig().content;

    // Verificar si content está definido antes de sobrescribir las propiedades
    if (content) {
      Object.assign(content, {
        header: environment.COOKIE_header,
        message: environment.COOKIE_message,
        dismiss: environment.COOKIE_dismiss,
        allow: environment.COOKIE_allow,
        deny: environment.COOKIE_deny,
        link: environment.COOKIE_link,
        cookiePolicyHref: environment.COOKIE_cookiePolicyHref,
        policy: environment.COOKIE_policy,
        privacyPolicyHref: environment.COOKIE_privacyPolicyHref,
        privacyGroupPolicyHref: environment.COOKIE_privacyGroupPolicyHref
      });
    }

    this.cookieConsentService.destroy(); // Remove previous cookie bar (with default messages)
    this.cookieConsentService.init(this.cookieConsentService.getConfig()); // Update config with translated messages
  }

  private subscribeToCookieConsentEvents(): void {
    this.cookieConsentService.popupOpen$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      // handle popup open event
      console.log("Popup opened");
    });

    this.cookieConsentService.popupClose$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      // handle popup close event
      console.log("Popup closed");
    });

    this.cookieConsentService.statusChange$.pipe(takeUntil(this.unsubscribe$)).subscribe((event: NgcStatusChangeEvent) => {
      // handle status change event
      console.log("Status changed", event);
    });

    this.cookieConsentService.noCookieLaw$.pipe(takeUntil(this.unsubscribe$)).subscribe((event: NgcNoCookieLawEvent) => {
      // handle no cookie law event
      console.log("No cookie law", event);
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe to all observables to prevent memory leaks
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
